import React, { useEffect, useLayoutEffect, useState } from "react";
import { Autocomplete, InputAdornment, InputLabel } from "@mui/material";
import { Box, Button, FormControl, FormControlLabel } from "@mui/material";
import { Grid, MenuItem, Radio, RadioGroup } from "@mui/material";
import { Select, Stack, styled, TextField, Typography } from "@mui/material";
import AddLedger from "./AddLedger";
import DialogComponent from "../reusableComponents/Dialog";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearLedgers, getLedgers, selectLedger } from "./ledgerSlice";
import { ledgerRemove, ledgerTotalRemove } from "./ledgerSlice";
import { removeLedger, searchLedger, updateOldLedger } from "./httpCalls";
import { getCompany } from "../company profile/companySlice";
import Loader from "../components/Loader";
import { BodyContainer, Header, TopGrid } from "../styles";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchIcon from "@mui/icons-material/Search";
import UpdateLedger from "./UpdateLedger";
// import { CheckBox } from "@material-ui/icons";
import Checkbox from "@mui/material/Checkbox";
import { BtnCancel, ButtonAdd } from "../styles";
import { GenerateReport } from "./LedgerReport";
import { CompareArrows } from "@mui/icons-material";
import { selectedLedger } from "./ledgerSlice";
import { filter } from "lodash";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const Cards = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px , 1fr ))",
  gap: "30px",
  marginBottom: "20px",
});
const Card = styled(Box)({
  background: "#4EAF51",

  color: "white",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
});
const Icon = styled(Box)({
  fontSize: "48px",
  color: "white",
});
const SearchField = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  height: "40px",
  lineHeight: "14.06px",
  backgroundColor: "#f9f9f9",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  borderBottom: "1px solid #999999 !important",
});

const ItemBox = styled(Box)({
  background: "white",
  padding: "18px",
  marginTop: "10px",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "7px",
});
export default function LedgersList() {
  const tokenType = localStorage.getItem("tokenType");
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    ledgers,
    loading,
    hasMore,
    token,
    salesTotal,
    purchasesTotal,
    filtered,
  } = useSelector((state) => state.ledger);
  const { company } = useSelector((state) => state.company);
  const companyCode = localStorage.getItem("companyCode");

  const [state, setState] = useState({
    updateModal: false,
    ledgerModal: false,
    deleteModal: false,
    updateOldDialog: false,
    updating: false,
    regionModal: false,
    ledgerButtontype: "customer",
    selectedToUpdate: "",
    loading: false,
    ledgerLoading: false,
    ledgerType: "All",
    isNew: false,
    titleModal: false,
    ledgers: [],
    salesTotal: 0,
    purchasesTotal: 0,
    selected_id: "",
    text: "",
    selected_ledger: "",
    open: false,
    type: "purchase",
    toggle: false,
    removeLedger: "",
    selectedLedger: "",
    delIndex: 0,
    updateInd: 0,
    selectedRegion: "",
  });
  const [searched, setSearched] = useState([]);
  const [searching, setSearching] = useState(false);
  const [ledgersList, setLedgersList] = useState([]);
  const [checked, setChecked] = React.useState(false);
  const [checkedAll, setCheckedAll] = React.useState(false);
  const [filteredData, setFilteredData] = useState([]);

  console.log("ledgersList", ledgersList);
  console.log("filteredData", filteredData);
  console.log("chekced", checked);
  console.log("chekcedAll", checkedAll);
  console.log("led", ledgersList);
  console.log("ledgerssss",ledgers);


  // useLayoutEffect(() => {
  //   dispatch(clearLedgers());
  // }, []);

  useEffect(() => {
    console.log("useEffect Triggered - company:", company);

    if (!company) {
      dispatch(getCompany());
    }
    let regions = tokenType == "admin" ? [] : company?.ledgerRegions;
    let obj = {
      ledgerRegions: regions,
      next_page_token: "",
    };
    // if(ledgers.length == 0) {
      console.log("useEffect ", ledgers);

      dispatch(getLedgers(obj));

    // }
  }, []);

  const loadLedgers = () => {
    let regions = tokenType == "admin" ? [] : company?.ledgerRegions;
    let obj = {
      ledgerRegions: regions,
      next_page_token: token,
    };
    if (token) {
      dispatch(getLedgers(obj));
    }
  };

  const searchs = () => {
    let { text, ledgerType, selectedRegion } = state;
    console.log("topsearch", state);
    text = text.toLowerCase();
    console.log("text", text);

    let filtered = [];
    if (searching) {
      filtered = searched;
    } else {
      filtered = ledgers;
      console.log("ss", ledgers);
    }
    if (!text && ledgerType == "All" && !selectedRegion) {
      return filtered;
    } else if (text && ledgerType != "All" && selectedRegion) {
      return filtered.filter(
        (item) =>
          item?.name.toLowerCase().includes(text) &&
          item?.ledgerType == ledgerType &&
          item?.region == selectedRegion
      );
    } else {
      if (selectedRegion && ledgerType != "All") {
        return filtered.filter(
          (item) =>
            (item.ledgerButtontype || item.ledgerType) == ledgerType &&
            item?.region == selectedRegion
        );
      } else if (text && ledgerType != "All") {
        return filtered.filter(
          (item) =>
            (item.ledgerButtontype || item.ledgerType) == ledgerType &&
            item?.name.toLowerCase().includes(text)
        );
      } else if (text && selectedRegion) {
        return filtered.filter(
          (item) =>
            item?.region == selectedRegion &&
            item?.name.toLowerCase().includes(text)
        );
      } else {
        if (selectedRegion) {
          return filtered.filter((item) => item?.region == selectedRegion);
        } else if (ledgerType != "All") {
          return filtered.filter(
            (item) => (item.ledgerButtontype || item.ledgerType) == ledgerType
          );
        } else if (text) {
          return filtered.filter((item) =>
            item?.name.toLowerCase().includes(text)
          );
        }
      }
    }
    console.log("filtered", filtered);

    // setLedgersList(filtered);
  };



  useEffect(() => {
    const filtered = searchs();
    setFilteredData(filtered);
  }, [state,ledgers]);

  const handleDelete = (id, index) => {
    setState((prev) => ({
      ...prev,
      deleteModal: true,
      removeLedger: id,
      delIndex: index,
    }));
  };

  const updateOldLedgers = async (arg) => {
    let ledger = {
      _id: state.selectedToUpdate._id,
      _rev: state.selectedToUpdate._rev,
      ledgerType: state.ledgerButtontype,
    };
    await updateOldLedger(ledger);
    updateOldToggle();
    loadLedgers();
  };

  const deleteToggle = () => {
    setState((prev) => ({ ...prev, deleteModal: !state.deleteModal }));
  };

  const onDelete = () => {
    deleteToggle();
    if (state.removeLedger.saleTotal) {
      let amount = state.removeLedger.saleTotal;
      dispatch(ledgerTotalRemove({ amount: amount, key: "saleTotal" }));
    }
    if (state.removeLedger.purchaseTotal) {
      let amount = state.removeLedger.purchaseTotal;
      dispatch(ledgerTotalRemove({ amount: amount, key: "purchaseTotal" }));
    }
    dispatch(ledgerRemove({ index: state.delIndex }));
    removeLedger(state.removeLedger, dispatch, state.delIndex);
  };

  const openKhata = (ledger, type) => {
    dispatch(selectLedger({ type, ledger }));
    history.push(
      `/inventory/${
        tokenType == "admin" ? "admin" : "dashboard"
      }/ledgers-details/${ledger._id}`
    );
  };

  const viewLedger = (item) => {
    setState((pre) => ({
      ...pre,
      open: true,
      selected_id: item._id,
      selected_ledger: item,
    }));
  };

  const openToggle = () => {
    setState((pre) => ({ ...pre, open: !state.open }));
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    if (name == "text" && !value) {
      setSearching(false);
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const editLedger = (item, index) => {
    let val = null;
    if (searched.length > 0) {
      val = "searched";
    } else if (state.text || state.ledgerType != "All") {
      val = "id";
    } else {
      val = index;
    }

    setState((pre) => ({
      ...pre,
      selectedLedger: item,
      updateModal: true,
      updateInd: val,
    }));
  };
  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };
  const updateOldToggle = (item, index) => {
    if (item) {
      setState((pre) => ({
        ...pre,
        updateOldDialog: !state.updateOldDialog,
        selectedToUpdate: item,
        selectedIndex: index,
      }));
    } else {
      setState((pre) => ({ ...pre, updateOldDialog: !state.updateOldDialog }));
    }
  };

  const searchRegion = (e, val) => {
    console.log("valll,", val);
    setState((prev) => ({ ...prev, selectedRegion: val }));
  };
  const handleOldLedger = (e) => {
    let value = e.target.value;
    setState((pre) => ({ ...pre, ledgerButtontype: value }));
  };
  const searchRegions = () => {
    if (company?.ledgerRegions) {
      console.log("company", company);

      return company.ledgerRegions;
    } else {
      return [];
    }
  };
  const handleLedger = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let res = await searchLedger(state.text);
    setSearched([...res]);
    setSearching(true);
    setState((prev) => ({ ...prev, loading: false }));
  };
  const updateSearched = (data) => {
    let copy = JSON.parse(JSON.stringify(searched));
    let found = copy.find((i) => i._id == data._id);
    if (found) {
      found.name = data.name;
      found.address = data.address;
      found.region = data.region;
    }
    setSearched(copy);
  };

  const handleChange = (event) => {
    const updatedChecked = [...checked];
    updatedChecked[index] = event.target.checked;
    setChecked(updatedChecked);
  };
  const handleChangeAll = (event) => {
    const isChecked = event.target.checked;
    setCheckedAll(isChecked);
    const updatedChecked = ledgers.map(() => isChecked);
    setChecked(updatedChecked);
  };

  const generateReportHandler = () => {
    const selectedRegion = state.selectedRegion;
    GenerateReport({ filteredData, ledgers, salesTotal, purchasesTotal,selectedRegion });
  };
  const searchData = filteredData.length > 0 ? filteredData : searchs();
  console.log("searchDataa", searchData);

  return (
    <Box>
      <Header sx={{ mt: { md: "5px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={2} xs={12} className="ml-n-16">
            <SearchField
              fullWidth
              size="small"
              height="40px"
              placeholder="search..."
              variant="outlined"
              name="text"
              value={state.text}
              onChange={handleSearch}
              onKeyDown={(e) => {
                // if (e.key === "Enter") {
                //   handleLedger();
                // }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="gray-clr" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid align="center" item lg={5} md={3} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Ledgers
            </Typography>
          </Grid>
          <Grid item lg={2} md={2} xs={6}>
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "80%" } }}
              onClick={() => generateReportHandler()}
            >
              Generate Report
            </ButtonAdd>
          </Grid>
          <Grid
            item
            lg={2}
            md={2}
            xs={6}
            sx={{ margin: "0 auto" }}
            className="ml-n-16"
          >
            <FormControl fullWidth size="small">
              <InputLabel>Ledger Type</InputLabel>

              <Select
                defaultValue=""
                name="ledgerType"
                variant="outlined"
                label="Ledger Type"
                sx={{ background: "#f9f9f9", width: "100%" }}
                onChange={handleSearch}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="customer">Customer</MenuItem>
                <MenuItem value="supplier">Supplier</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={1} md={2} xs={5} sx={{ margin: "0 auto" }}>
            <AddLedger />
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer>
        <Cards>
          <Card
            sx={{
              background: "red",
              mt: { md: "0px", xs: "40px" },
              height: { md: "120px", xs: "80px" },
            }}
          >
            <Icon className="fa fa-arrow-alt-circle-up"></Icon>
            <Stack direction="column">
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: { md: "16px", xs: "10px" },
                }}
                variant="h6"
              >
                {Math.ceil(purchasesTotal)}
              </Typography>

              {companyCode == "5073" ? (
                <Typography
                  variant="h6"
                  sx={{ fontSize: { md: "1.5rem", xs: "10px" } }}
                >
                  Pak Rs Balance
                </Typography>
              ) : (
                <Typography
                  variant="h6"
                  sx={{ fontSize: { md: "1.5rem", xs: "10px" } }}
                >
                  Aap ne dene Hai
                </Typography>
              )}
            </Stack>
          </Card>
          <Card sx={{ height: { md: "120px", xs: "80px" } }}>
            <Icon className="fas fa-arrow-alt-circle-down"></Icon>
            <Stack direction="column">
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: { md: "16px", xs: "10px" },
                }}
                variant="h6"
              >
                {Math.ceil(salesTotal)}
              </Typography>
              {companyCode == "5073" ? (
                <Typography
                  variant="h6"
                  sx={{ fontSize: { md: "1.5rem", xs: "10px" } }}
                >
                  Aed Balance
                </Typography>
              ) : (
                <Typography
                  variant="h6"
                  sx={{ fontSize: { md: "1.5rem", xs: "10px" } }}
                >
                  Aap ne Wasool Karne Hai
                </Typography>
              )}
            </Stack>
          </Card>
        </Cards>

        <Grid container justifyContent="flex-end">
          {/* <Grid item md={5.8} xs={12}>
            <Checkbox
              checked={checkedAll}
              onChange={handleChangeAll}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid> */}
          <Grid item md={5.8} xs={12}>
            <Autocomplete
              size="small"
              onChange={(e, val) => {
                searchRegion(e, val);
              }}
              sx={{ background: "white" }}
              // defaultValue={state.selectedRegion ?? ""}
              getOptionLabel={(option) => option || ""}
              id="controllable-states-demo"
              options={searchRegions()}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Region"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>
        <InfiniteScroll
          dataLength={ledgers.length}
          next={loadLedgers}
          hasMore={hasMore}
          loader={token == "" ? "" : <h2 align="center">Loading...</h2>}
          endMessage={
            <h2 style={{ textAlign: "center" }}>
              <b>No More Ledgers</b>
            </h2>
          }
        >
          {/* {!loading && searchs().length == 0 && (
            <h2 style={{ textAlign: "center" }}>
              <b>No Ledgers</b>
            </h2>
          )} */}
          {!loading && searchData.length == 0 && (
            <h2 style={{ textAlign: "center" }}>
              <b>No Ledgers</b>
            </h2>
          )}
          {!state.loading &&
            searchData.map((ledger_item, index) => {
              return (
                <ItemBox key={index}>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-evenly"
                  >
                    <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
                      {index + 1}
                    </Typography>
                    {/* <Checkbox
                      checked={checkedAll ? checked : checked[index]}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    /> */}

                    <Typography
                      sx={{
                        width: "30%",
                        color: "#4CAF50",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: { md: "16px", xs: "10px" },
                      }}
                      onClick={() => editLedger(ledger_item, index)}
                    >
                      {ledger_item.name}
                    </Typography>
                    <Stack sx={{ marginLeft: "10px !important" }}>
                      <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
                        {ledger_item.purchaseTotal
                          ? Math.ceil(ledger_item.purchaseTotal)
                          : 0}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#4CAF50",
                          textDecoration: "underline",
                          fontSize: { md: "16px", xs: "10px" },
                          cursor: "pointer",
                        }}
                        onClick={() => openKhata(ledger_item, "purchase")}
                      >
                        {companyCode == "5073"
                          ? "Pak Rs Balance"
                          : "Purchase Khata"}
                      </Typography>
                      {companyCode !== "5073" && (
                        <Typography
                          sx={{ fontSize: { md: "16px", xs: "10px" } }}
                        >
                          Dene Hai
                        </Typography>
                      )}
                    </Stack>
                    <Stack sx={{ marginLeft: "10px !important" }}>
                      <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
                        {/* {(ledger_item.saleTotal &&  ledger_item.saleTotal > 0)
                          ? Math.ceil(ledger_item.saleTotal ) */}
                        {ledger_item.saleTotal
                          ? Math.ceil(ledger_item.saleTotal)
                          : 0}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#4CAF50",
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontSize: { md: "16px", xs: "8px" },
                        }}
                        onClick={() => openKhata(ledger_item, "sale")}
                      >
                        {companyCode == "5073" ? "Aed Balance" : "Sale Khata"}
                      </Typography>
                      {companyCode !== "5073" && (
                        <Typography
                          sx={{ fontSize: { md: "16px", xs: "10px" } }}
                        >
                          Lene Hai
                        </Typography>
                      )}
                    </Stack>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 3 }}
                    >
                      <Button
                        size="small"
                        sx={{
                          color: "#fff",
                          background: "#4EAF51 !important",
                          padding: "2px 12px",
                          minWidth: { xs: 0 },
                        }}
                        onClick={() => viewLedger(ledger_item)}
                      >
                        <i className="fas fa-eye"></i>
                      </Button>
                      {companyCode !== "4890" && (
                        <Button
                          sx={{
                            color: "#fff",
                            background: "red !important",
                            padding: "2px 12px",
                            lineHeight: { xs: 0 },
                            minWidth: { xs: 0 },
                          }}
                          size="small"
                          onClick={() => handleDelete(ledger_item, index)}
                        >
                          <span>
                            <i
                              style={{ color: "white" }}
                              className="fas fa-trash"
                            ></i>
                          </span>
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </ItemBox>
              );
            })}
        </InfiniteScroll>
      </BodyContainer>
      <DialogComponent
        title="View Ledger"
        open={state.open}
        onClose={openToggle}
        onClickCancel={openToggle}
        dialogContent={
          <Stack spacing={3}>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
              variant="h6"
            >
              Please select the ledger type you want to open
            </Typography>
            <Stack direction="row" width="100%" justifyContent="space-evenly">
              <Button
                variant="contained"
                onClick={() => openKhata(state.selected_ledger, "sale")}
              >
                Sale Ledger
              </Button>
              <Button
                variant="contained"
                onClick={() => openKhata(state.selected_ledger, "purchase")}
                sx={{ mt: { md: "0px", xs: "8px" } }}
              >
                Purchase Ledger
              </Button>
            </Stack>
          </Stack>
        }
      />

      {state.updateModal && (
        <UpdateLedger
          open={state.updateModal}
          onClose={() => toggle("updateModal")}
          ledger={{ ...state.selectedLedger, index: state.updateInd }}
          onUpdate={(e) => updateSearched(e)}
        />
      )}

      <DialogComponent
        title="Update Old Ledger"
        open={state.updateOldDialog}
        onClose={updateOldToggle}
        onClickCancel={updateOldToggle}
        dialogContent={
          <Stack direction="column" spacing={2}>
            <Typography variant="h6" sx={{ color: "#4EAF51" }}>
              Update Ledger
            </Typography>

            <div style={{ padding: "10px" }}>
              <input
                required
                placeholder="Enter Name"
                value={state.selectedToUpdate?.name}
                style={{
                  background: "#EBEBEB",
                  outline: "white",
                  border: "1px solid white",
                  padding: "10px",
                  width: "100%",
                }}
              />
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="supplier type"
                  value={state.ledgerButtontype}
                  onChange={handleOldLedger}
                >
                  <FormControlLabel
                    value="customer"
                    control={<Radio />}
                    label="Customer"
                  />
                  <FormControlLabel
                    value="supplier"
                    control={<Radio />}
                    label="Supplier"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <Stack direction="row" justifyContent="space-around">
              <Button
                variant="contained"
                sx={{ background: "#4EAF51" }}
                onClick={updateOldLedgers}
                autoFocus
              >
                Save
              </Button>
              <Button variant="outlined" onClick={updateOldToggle}>
                Cancel
              </Button>
            </Stack>
          </Stack>
        }
      />

      <DeleteDialog
        title="Delete Ledger"
        open={state.deleteModal}
        onClose={deleteToggle}
        onClickYes={onDelete}
      />

      {ledgers.length == 0 && <Loader loading={loading} />}
      {state.loading && <Loader loading={state.loading} />}
    </Box>
  );
}
